import { render, staticRenderFns } from "./DashboardLayout.vue?vue&type=template&id=4977e71c&"
import script from "./DashboardLayout.vue?vue&type=script&lang=js&"
export * from "./DashboardLayout.vue?vue&type=script&lang=js&"
import style0 from "./DashboardLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4977e71c')) {
      api.createRecord('4977e71c', component.options)
    } else {
      api.reload('4977e71c', component.options)
    }
    module.hot.accept("./DashboardLayout.vue?vue&type=template&id=4977e71c&", function () {
      api.rerender('4977e71c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/DashboardLayout.vue"
export default component.exports